import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { CurrentUserService } from "src/app/core/services/current-user.service";
import { FlashMessageService } from "src/app/shared/services/flash-message.service";
import { CustomerService } from "src/app/services/customer/customer.service";
import { ErrorHandlerService } from "src/app/shared/services/error-handler.service";
import { ModalService } from "src/app/shared/services/modal.service";
import { GoogleAnalyticsService } from "src/app/shared/services/google-analytics/google-analytics.service";

@Component({
  selector: "app-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
})
export class ConfirmCustomerComponent implements OnInit {
  public loading: boolean = false;
  public companyName: string;
  public customerId: string;
  public sub: any;
  private redirectUrl: string;
  public companyInfo: any;

  constructor(
    public customerService: CustomerService,
    public currentUserService: CurrentUserService,
    private _gaSvc: GoogleAnalyticsService,
    private flashMessageService: FlashMessageService,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private modal: ModalService
  ) { }

  ngOnInit() {
    if (!this.customerService.newCustomerUser.name) {
      this.router.navigate(["../../"], { relativeTo: this.route });
    }
    this.sub = this.route.queryParams.subscribe((params) => {
      this.customerId = params["customerID"];
      this.redirectUrl = params["urlPath"]
        ? params["urlPath"].split(`'`)[1]
        : null;
    });

    this.companyInfo = this.customerService.getCustomer(
      this.customerService.newCustomerUser.organization_id
    );
  }

  confirm() {
    this.loading = true;
    this.customerService
      .createCustomerUser()
      .then((response) => {
        if (this.customerService.newCustomerUser.user_from_request) {
          this.customerService.removeCustomerRequest();
        }

        this._gaSvc.register(
          "Create Customer User",
          "Create Customer User for User Role: " +
          this.customerService.newCustomerUser.roleCode,
          "Create Customer User for Customer: " +
          this.customerService.newCustomerUser.organizationName
        );

        this.customerService.resetCustomerUser();
        this.loading = false;
        this.flashMessageService.updateMessage(
          "Successfully created user",
          3000,
          "success"
        );
        this.modal.close();
      })
      .catch((err) => {
        this.loading = false;
        if (err.status === 409) {
          this.flashMessageService.updateMessage(err["error"]["error"], 3000);
        } else {
          this.flashMessageService.updateMessage(
            "Failed to Add New User.",
            3000
          );
        }
      });
  }

  onEditDetails() {
    this.router.navigate([{ outlets: { cust: "create" } }], {
      queryParams: {
        edit: true,
        customerID: this.customerService.newCustomerUser.organization_id,
        name: this.customerService.newCustomerUser.name,
        email: this.customerService.newCustomerUser.email,
        phone: this.customerService.newCustomerUser.phone,
        mobile: this.customerService.newCustomerUser.mobile_phone,
        userType: this.customerService.newCustomerUser.roleCode,
        entitlements: this.customerService.newCustomerUser.entitlements,
        origins: this.customerService.newCustomerUser.allowed_origin_locations,
        destinations: this.customerService.newCustomerUser
          .allowed_destination_locations,
      },
    });
  }
}
